import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {LeadService} from '../services/lead.service';

@Component({
    selector: 'app-settings',
    templateUrl: '../views/settings.component.html',
    styleUrls: ['../css/settings.component.css']
})
export class SettingsComponent implements OnInit {
    public current: any = [];
    public remaining: any = [];
    public index: number;
    public addToRemaining: any = [];
    public addTocurrent: any = [];
    public savePreference: any;
    public userId: string;
    public AllFields: any = [];
    public prepareCurrentToSave: any = [];
    public test: any = [];
    public allSettingsData: any = [];
    public refine: any = [];
    public id: number;
    public userPrefData: any = [];
    public countIndex: any = [];
    public count: number = 0;
    public showToSelect: boolean = false;
    constructor(public _leadService: LeadService, public _router: Router) {}

    ngOnInit() {
        //this.userId = localStorage.getItem('userId');
        this.userId = sessionStorage.getItem('userId');
        this.getPreference();
    }

    /**
     * @author Nagendra
     * @param value (selected value)
     * @description If value exist in addToRemaining then remove else add
     */
    fromCurrent(value, index) {
      const assign = document.getElementById("current_" + index);
      assign.classList.toggle("active");
        if (this.addToRemaining.indexOf(value) !== -1) {
            this.index = this.addToRemaining.indexOf(value);
            this.addToRemaining.splice(this.index, 1)
        }
        else {this.addToRemaining.push(value);}
    }

    /**
     * @author Nagendra
     * @param value (selected value)
     * @description If value exist in addTocurrent then remove else add
     */
    fromRemaining(value, index) {
      const assign = document.getElementById("remaining_" + index);
      assign.classList.toggle("active");
        if (this.addTocurrent.indexOf(value) !== -1) {
            this.index = this.addTocurrent.indexOf(value);
            this.addTocurrent.splice(this.index, 1)
        }
        else {this.addTocurrent.push(value);}
    }


    /**
     * @author Nagendra
     * @event click 
     * @description OnClick add to remaining and remove values from current
     */
    filterCurrent() {
        this.addToRemaining.forEach(Obj => {
            this.remaining.push(Obj)
        });
        this.addToRemaining.forEach(each => {
            this.index = this.current.indexOf(each);
            this.current.splice(this.index, 1)
        });
        this.addToRemaining = [];
    }

    /**
    * @author Nagendra
    * @event click 
    * @description OnClick add to current and remove values from remaining
    */
    filterRemaining() {
        this.addTocurrent.forEach(Obj => {
            this.current.push(Obj)
        });
        this.addTocurrent.forEach(each => {
            this.index = this.remaining.indexOf(each);
            this.remaining.splice(this.index, 1)
        });
        this.addTocurrent = [];
    }

    saveUserPreference() {
        this.savePreference = {};
        this.prepareCurrentToSave = [];
        this.countIndex = [];
        if (this.current != '') {
            this.showToSelect = false;
            this._leadService.getviewSettings((allPreference) => {
                allPreference.forEach(res => {
                    this.current.forEach((obj, index) => {
                        if (obj == res.label) {
                            this.countIndex.push(-1);
                            //calling Get User Preference API to check whether id values exist 
                            this.userPrefData.forEach(result => {
                                //If current view label & getUserPreference label matches
                                if (result.setting.label == obj) {
                                    this.countIndex.splice(index, 1);
                                    this.countIndex.splice(index, 0, result.id);
                                }
                                if (this.countIndex[index] == undefined) {
                                    this.countIndex.splice(index, 1);
                                    this.countIndex.splice(index, 0, -1);
                                }
                            });


                          const seq = index;
                          this.prepareCurrentToSave.push({
                                "id": this.countIndex[index],
                                "userId": this.userId,
                                "setting": {
                                    "id": res.id,
                                    "label": res.label,
                                    "property": res.property,
                                    "isDefult": res.isDefult,
                                    "sequence": res.sequence,
                                },
                                sequence: seq + 1
                            });
                        }
                    });
                });
                this._leadService.saveUserPreference(this.prepareCurrentToSave, result => {
                    this._router.navigate(['leads']);
                });
            });
        } else {this.showToSelect = true;}

    }

    getPreference() {
        this.current = [];
        this.remaining = [];
        this._leadService.getUserPreference(this.userId, (result) => {
            this.userPrefData = result;
            if (result.length != 0) {
                result.sort((a: any, b: any) => {
                    if (a.sequence < b.sequence) {
                        return -1;
                    } else if (a.sequence > b.sequence) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                result.forEach(each => {
                  const index = (each.sequence - 1);
                  this.current.splice(index, 0, each.setting.label);
                });
                this._leadService.getviewSettings(allPreference => {
                    allPreference.forEach(res => {
                        this.refine.push(res.label);
                    });
                  const thisObj = this;
                  this.refine.filter(function (item) {
                        if (thisObj.current.indexOf(item) === -1) {thisObj.remaining.push(item)}
                    });
                });
            } else {
                [this.current, this.remaining] = this._leadService.setDefaultPreferenceForLead(this.current, this.remaining);
            }
        });

    }

    reset() {
        this._router.navigate(['leads']);
    }


}



// WEBPACK FOOTER //
// ./src/app/modules/leads/components/settings.component.ts